import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { XIcon } from '@repo/icons';
import { getLabels } from '../labels';
import { useModal } from './useModal';
const widthClasses = {
    sm: 'md:w-96',
    md: 'md:w-120',
    lg: 'md:w-150',
};
export default function Modal({ children, testId, title, footer, flush = false, width = 'lg', onOpenChange, open = false, portalTo, dismissableOnClickOutside = true, }) {
    const { expanded, shouldRender, modalRef, handleBackdropClick } = useModal({
        onOpenChange,
        open,
        dismissableOnClickOutside,
    });
    const labels = getLabels().modal;
    const titleId = useId();
    const handleCloseClick = () => onOpenChange?.(false);
    if (!shouldRender) {
        return null;
    }
    const modal = (_jsx("div", { className: classNames('z-overlay fixed inset-0 transition-colors duration-300', expanded ? 'bg-black/50' : 'pointer-events-none bg-transparent'), onClick: handleBackdropClick, children: _jsx("div", { ref: modalRef, role: "dialog", "aria-modal": "true", "aria-labelledby": title ? titleId : undefined, className: classNames('absolute bottom-0 left-0 w-full transition-all duration-300 ease-in-out md:top-1/2 md:bottom-auto md:left-1/2 md:-translate-x-1/2', widthClasses[width], portalTo ? 'z-modal' : 'z-2', expanded
                ? 'translate-y-0 md:-translate-y-1/2 md:opacity-100'
                : 'translate-y-full md:pointer-events-none md:-translate-y-1/2 md:opacity-0'), "data-testid": testId, children: _jsxs("div", { className: classNames('isolate flex max-h-[90vh] flex-col overflow-hidden md:rounded-2xl', 'drop-shadow-2xl drop-shadow-gray-950/50', 'bg-primary'), children: [_jsxs("div", { className: classNames('min-h-0 flex-1 overflow-y-auto transition-opacity duration-300 ease-in-out'), children: [title && (_jsxs("div", { className: "text-heading flex flex-row justify-between px-4 pt-4", children: [_jsx("h2", { id: titleId, className: "text-xl font-medium", children: title }), _jsx("button", { type: "button", className: "cursor-pointer", onClick: handleCloseClick, "aria-label": labels.closeAria, "data-testid": testId.append('close'), children: _jsx(XIcon, { size: 20 }) })] })), _jsx("div", { className: flush ? undefined : 'px-4', children: children })] }), footer && (_jsx("div", { className: "bg-primary relative z-2 px-4 pb-[max(1.25rem,env(safe-area-inset-bottom))]", children: footer }))] }) }) }));
    if (portalTo) {
        return createPortal(modal, portalTo);
    }
    return modal;
}
